import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 flex items-center justify-center z-50" }
const _hoisted_2 = { class: "bg-gray-800 text-white rounded-lg shadow-xl border border-gray-700 p-5 max-w-md z-10 w-full mx-4 md:w-auto" }
const _hoisted_3 = { class: "flex justify-between items-start mb-4" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "flex justify-center space-x-6" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "text-sm text-gray-400 mb-4" }
const _hoisted_8 = { class: "font-medium" }
const _hoisted_9 = { class: "flex justify-end space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-lg font-medium text-blue-400" }, "Ocenite korisnika", -1)),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          class: "text-gray-400 hover:text-gray-300 transition-colors"
        }, _cache[6] || (_cache[6] = [
          _createElementVNode("svg", {
            class: "h-5 w-5",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
              "clip-rule": "evenodd"
            })
          ], -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-sm text-gray-300 mb-2" }, "Izaberite ocenu:", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('setRatingLike', true))),
            class: _normalizeClass(["p-3 rounded-lg flex flex-col items-center transition-colors", 
              _ctx.ratingModal.isLike === true
                ? 'bg-green-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            ])
          }, _cache[8] || (_cache[8] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "32",
              height: "32",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              class: "mb-2"
            }, [
              _createElementVNode("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })
            ], -1),
            _createElementVNode("span", { class: "font-medium" }, "Pozitivno", -1)
          ]), 2),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('setRatingLike', false))),
            class: _normalizeClass(["p-3 rounded-lg flex flex-col items-center transition-colors", 
              _ctx.ratingModal.isLike === false
                ? 'bg-red-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            ])
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "32",
              height: "32",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              class: "mb-2"
            }, [
              _createElementVNode("path", { d: "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" })
            ], -1),
            _createElementVNode("span", { class: "font-medium" }, "Negativno", -1)
          ]), 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[11] || (_cache[11] = _createElementVNode("label", {
          for: "ratingComment",
          class: "block text-sm text-gray-300 mb-2"
        }, "Vaš komentar (opcionalno):", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "ratingComment",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ratingModal.comment) = $event)),
          class: "w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-white text-sm",
          rows: "3",
          placeholder: "Opišite vaše iskustvo sa ovim korisnikom..."
        }, null, 512), [
          [_vModelText, _ctx.ratingModal.comment]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[12] || (_cache[12] = _createTextVNode(" Tip ocene: ")),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.ratingModal.ratingType === 'buyer'
            ? 'Prodavac ocenjuje kupca'
            : 'Kupac ocenjuje prodavca'), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close'))),
          class: "px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-500 transition-colors"
        }, " Otkaži "),
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('submit'))),
          class: "px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        }, " Potvrdi ")
      ])
    ])
  ]))
}